import { Link } from "gatsby"
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import React from "react"
import { FaBath, FaBed, FaSwimmingPool, FaUncharted } from "react-icons/fa"
import Separator from "../../../utils/separator"
export default function Property({
  slug,
  id,
  reff,
  title,
  type,
  location,
  price,
  image,
  area,
  bed,
  bath,
  propertyID,
  sold,
  pool,
  land,
}) {
  return (
    <div
      ref={reff}
      className={`w-72 rounded-lg md:w-96 grid bg-white shadow hover:shadow-lg shadow-stone-600/10 transition ease-in-out duration-300 filter ${id}`}
    >
      <Link to={slug} className="h-64 p-2 overflow-hidden relative">
        {sold && (
          <span className="bg-yellow-500 font-bold text-white px-5 py-1 z-10 absolute right-0 rounded-lg uppercase tracking-widest text-xs rotate-[43deg] top-6">
            Sold
          </span>
        )}
        {image ? (
          <GatsbyImage
            image={image}
            alt={title}
            className="h-64 rounded-lg overflow-hidden object-cover w-full"
          />
        ) : (
          <StaticImage
            src="https://images.unsplash.com/photo-1576670394403-8417e87d4669?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1528&q=80"
            alt={title}
            className="h-64 rounded-lg overflow-hidden object-cover w-full"
          />
        )}
      </Link>
      <div className="p-4">
        <span className="text-xs tracking-widest text-stone-400 font-thin">
          Ref: {propertyID}
        </span>
        <Link to={slug}>
          <h3 className="font-bold capitalize">{title}</h3>
        </Link>
        <div>
          {type && (
            <span className="text-xs tracking-widest uppercase">{type}</span>
          )}
          {location && (
            <span className="text-xs tracking-widest uppercase">
              {", " + location}
            </span>
          )}
        </div>
        <div className="flex justify-between">
          <p className={`text-teal-600 text-2xl font-medium`}>
            {Separator(price)}
          </p>
          <Link
            className="px-5 py-2 rounded bg-black shadow shadow-stone-700/20 text-white text-xs"
            to={slug}
          >
            Learn More
          </Link>
        </div>
        <div className="flex justify-between text-xs text-stone-400 pt-4">
          {land && (
            <div className="flex flex-col space-y-3 items-center">
              <StaticImage
                src="../../../images/3606497.png"
                quality={100}
                className="h-5 w-5"
                alt="land icon"
              />
              <span>{land} M2 Land</span>
            </div>
          )}
          {area && (
            <div className="flex flex-col space-y-3 items-center">
              <FaUncharted className="text-xl text-stone-500" />
              <span>{area} M2 Surface</span>
            </div>
          )}
          {bed && (
            <div className="flex flex-col space-y-3 items-center">
              <FaBed className="text-xl text-stone-500" />
              <span>{bed} Bedrooms</span>
            </div>
          )}
          {bath && (
            <div className="flex flex-col space-y-3 items-center">
              <FaBath className="text-xl text-stone-500" />
              <span>{bath} Bathrooms</span>
            </div>
          )}
          <div className="flex flex-col space-y-3 items-center">
            <FaSwimmingPool className="text-xl text-stone-500" />
            <span>{pool ? "Yes" : "No"} </span>
          </div>
        </div>
      </div>
    </div>
  )
}
